<template>
  <GlobalFooter class="i-copyright" :links="links" :copyright="copyright" />
</template>
<script>
  import Setting from '../../setting';

  export default {
    name: 'i-copyright',
    computed: {
      copyright() {
        return Setting.info.copyright;
      }
    },
    data() {
      return {
        links: []
      };
    }
  };
</script>
<style lang="less">
  .i-copyright {
    flex: 0 0 auto;
  }
</style>
